import AbstractShape from "@/Models/Shapes/AbstractShape";
import { PreviewShapeFactory } from "@/Models/Shapes/PreviewShapeFactory";
import ShapeConfigurationFactory from "@/Models/ShapeConfigurations/ShapeConfigurationFactory";
import { convertUnits } from "@/functions/numbers";

export default {
	namespaced: true,
	getters: {
		getInstance: ( state, getters, rootState, { measurements } ): AbstractShape => {
			return ( new PreviewShapeFactory() ).get( {
				shape: 'isosceles-triangle',
				dimensions: measurements.dimensions,
				modifiers: measurements.modifiers,
			} );
		},
		cutoutPrimitives: ( state, getters, rootState, { cutoutMeasurements } ): object => {
			return convertUnits( cutoutMeasurements.dimensions[ 'isosceles-triangle' ] );
		},
		getCutoutArea: ( state, getters, rootState, { cutoutMeasurements, getArea } ): number => {
			return getArea( 'isosceles-triangle', cutoutMeasurements.dimensions[ 'isosceles-triangle' ] );
		},
		isCenteredShape: (): boolean => false,
		getArea: ( state, getters, rootState, { getArea, parsedDimensions } ): object => {
			return getArea( 'isosceles-triangle', parsedDimensions );
		},
	},
};
